import { useI18n } from "vue-i18n";
import dayjs from "dayjs";
import type { VisitWithFields } from "@/api/visits";
import { useDateUtils } from "./dates";

export function useVisits() {
  const { t } = useI18n();
  const { formatDuration } = useDateUtils();

  const duration = (visit?: VisitWithFields) => {
    if (!visit?.startedAt || !visit?.finishedAt) {
      return t("emptyValue");
    }

    const visitDuration = dayjs.duration(
      dayjs(visit.finishedAt).diff(dayjs(visit.startedAt)),
      "milliseconds"
    );

    return formatDuration(visitDuration);
  };

  return {
    duration,
  };
}
